import { makeAutoObservable } from 'mobx';
import { environment } from '@environment';
import { HaptikEventName } from 'core/enums/haptik-events';
import { HaptikLaunchMessage } from 'core/enums/haptik-launch-messages';
import { HaptikBody, HaptikEvent, HaptikInitconfig } from 'core/models/haptik';
import HaptikService from 'core/services/api/haptik';

export class HaptikStore {
  isLoading!: boolean;
  canSignIn = false;
  isOpened = false;
  isScriptLoaded = false;
  useCustomButton = true;

  haptikGuestConfig: HaptikInitconfig = {
    'business-id': environment.HAPTIK_SS_BUSINESS_ID,
    'client-id': environment.HAPTIK_SS_CLIENT_ID,
    'base-url': environment.HAPTIK_BASE_URL,
    'privacy-policy-url': environment.HAPTIK_PRIVACY_POLICY_URL,
    'blacklisted-params': '',
    'custom-css': '',
    'initialize-language': 'en',
    sdkEvents: (event: any) => {
      this.handleSDKEvent(event);
    },
  };
  haptikSignInConfig: HaptikInitconfig = { ...this.haptikGuestConfig, 'signup-type': 'third_party' };

  currentConfig = this.haptikSignInConfig;
  constructor() {
    makeAutoObservable(this);
  }

  populateAuthData(authData: HaptikBody) { }

  onInit() {
    this.changeIsOpened(false);
    if (!this.isScriptLoaded) {
      HaptikService.loadHaptikScript();
      this.changeIsScriptLoaded(true);

      HaptikService.initialise(this.haptikGuestConfig);

      HaptikService.waitForSDK().then(() => {
        this.changeCanSignIn(true);
      });
    }
  }

  loadSignInBot(haptikBodyObject: HaptikBody) {
    this.changeIsOpened(false);
    HaptikService.replaceSDK(this.haptikSignInConfig);
    HaptikService.waitForSDK().then(() => {
      // const haptikBodyObject: HaptikBody = {
      //   agreementId: '123',
      //   authenticated: true,
      //   connectId: '456',
      //   countryCode: 'US',
      //   customerNumber: '789',
      //   email: 'test@example.com',
      //   idToken: 'token123',
      //   mobileNumber: '1234567890',
      // };

      HaptikService.signIn(haptikBodyObject);
      this.changeIsOpened(false);
    });
  }

  handleSDKEvent(event: HaptikEvent) {
    if (event.event_name === HaptikEventName.HAPTIK_APP_EXPANDED) {
      this.changeIsOpened(true);
    }
    if (event.event_name === HaptikEventName.HAPTIK_APP_MINIMIZED) {
      this.changeIsOpened(false);
    }
  }

  showApp(launchMessage?: HaptikLaunchMessage) {
    if (launchMessage) {
      HaptikService.launchMessage(launchMessage, true, false);
    } else {
      HaptikService.showApp();
    }
  }

  hideApp = () => {
    HaptikService.hideApp();
    //FIXME: Hiding app via Haptik.hide() is not triggering minimised Event
    this.changeIsOpened(false);
  };

  changeIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
  changeIsOpened(_value: boolean) {
    this.isOpened = _value;

    if (this.useCustomButton) {
      const wrapper = document.getElementById('haptik-xdk-wrapper');
      if (wrapper) {
        _value ? (wrapper.style.display = 'block') : (wrapper.style.display = 'none');
      }
    }
  }
  changeCurrentConfig(_value: HaptikInitconfig) {
    this.currentConfig = _value;
  }
  changeIsScriptLoaded(_value: boolean) {
    this.isScriptLoaded = _value;
  }
  changeCanSignIn(_value: boolean) {
    this.canSignIn = _value;
  }
  changeUseCustomButton(_value: boolean) {
    this.useCustomButton = _value;
  }
  changeDisplayFooterButton(_value: boolean) { }
}